import { render, staticRenderFns } from "./Providers.vue?vue&type=template&id=4078c54f&scoped=true&"
import script from "./Providers.vue?vue&type=script&lang=js&"
export * from "./Providers.vue?vue&type=script&lang=js&"
import style0 from "./Providers.vue?vue&type=style&index=0&id=4078c54f&lang=scss&scoped=true&"
import style1 from "./Providers.vue?vue&type=style&index=1&id=4078c54f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4078c54f",
  null
  
)

export default component.exports